import { render, staticRenderFns } from "./PopupAddressList.vue?vue&type=template&id=13a9ad76&"
import script from "./PopupAddressList.vue?vue&type=script&lang=js&"
export * from "./PopupAddressList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports